<template>
  <ul class="p-the-category-list">
    <li
      v-for="(category, key) in itemCategories"
      :key="key"
      class="p-the-category-list__item"
    >
      <DropdownMenuAnimation>
        <template #trigger>
          <span class="p-the-category-list__item__trigger">
            <!-- <IconItemCategory :id="category.id" /> -->
            <InlineSvg
              v-if="category.icon"
              :src="category.icon"
              width="30"
              height="30"
              :fill="colorCode"
              :aria-label="category.name"
            />

            <span class="p-the-category-list__item__trigger__label">{{
              category.name
            }}</span>
          </span>
        </template>
        <template #arrow>
          <IconBase view-box="0 0 24 24" width="24" height="24" color="#b6b6b6">
            <IconArrowBottom />
          </IconBase>
        </template>
        <template #target>
          <ul class="p-the-category-list__item__target">
            <li
              v-for="(child, key) in category.sub_categories"
              :key="key"
              class="p-the-category-list__item__target__item"
            >
              <a
                class="p-the-category-list__item__target__item__link"
                @click="clickOnSubcategory(child.id)"
                >{{ child.name }}</a
              >
            </li>
            <li class="p-the-category-list__item__target__item">
              <a
                class="p-the-category-list__item__target__item__link"
                @click="clickOnSubcategory(category.id)"
                >全て見る</a
              >
            </li>
          </ul>
        </template>
      </DropdownMenuAnimation>
    </li>
  </ul>
</template>
<script lang="ts">
//import IconItemCategory from "@/common/components/icons/IconItemCategory.vue";
import DropdownMenuAnimation from "@/general/components/organisms/DropdownMenuAnimation.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowBottom from "@/common/components/icons/IconArrowBottom.vue";
import { Options, Vue } from "vue-class-component";
import InlineSvg from "vue-inline-svg";
import commons from "@/common/store/modules/commons";
import { mapState } from "vuex";

@Options({
  props: {
    categories: { type: Array, required: true },
    link: { type: Boolean, required: false, default: false }
  },
  components: {
    //IconItemCategory,
    DropdownMenuAnimation,
    IconBase,
    IconArrowBottom,
    InlineSvg
  },
  computed: {
    ...mapState({
      colorCode: () => commons.colorCode
    })
  }
})
export default class TheCategoryList extends Vue {
  categories!: any;
  link!: boolean;

  get itemCategories() {
    return this.categories;
  }

  clickOnSubcategory(id: number) {
    if (this.link) {
      window.location.href = "/product-list/?product-category=" + id;
    } else {
      window.history.pushState("", "", "/product-list/?product-category=" + id);
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      this.$emit("click-subcategory", id);
    }
  }

  clickOnMainCategory(id: number) {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
    this.$emit("click-subcategory", id);
  }
}
</script>

<style lang="scss" scoped>
.p-the-category-list {
  &__item {
    &__trigger {
      padding: rem(8) 0;
      border-bottom: px(1) solid #dadada;
      width: 100%;
      display: flex;
      align-items: center;

      &__label {
        font-weight: bold;
        margin-left: rem(16);
      }
    }

    &__target {
      margin-left: rem(52);
      padding-top: rem(8);

      &__item {
        &__link {
          padding: rem(4) 0;
        }

        &:last-child {
          margin-top: rem(16);
        }
      }
    }
  }
}
</style>
